import React, { useState, useEffect, useContext } from 'react';

import {

    getSuppliers,

    ListPurchaseOrder,

    PurchasesReturn,

    postGeneralData,

    getInvoiceNumber,

    UpdatePaymentComplete

} from '../../../Utility/Api';

import './style.css';

import { toast } from "react-toastify";

import { WarehouseContext } from '../../../Utility/UserContext';

import { getFormattedCurrentDate2, onReqCreatePayment } from '../../../Utility/function';

import Modal from 'react-bootstrap/Modal';

import Button from 'react-bootstrap/Button';



const PurchaseReturn = () => {

    const [invoiceNumber, setInvoiceNumber] = useState('');

    const [suppliers, setSuppliers] = useState([]);

    const [selectedSupplierId, setSelectedSupplierId] = useState('');

    const [selectedSupplier, setSelectedSupplier] = useState(null);

    const [orders, setOrders] = useState([]);

    const [selectedProduct, setSelectedProduct] = useState(null);

    const [returnSerials, setReturnSerials] = useState([]);

    const [availableSerials, setAvailableSerials] = useState([]);

    const [returnReason, setReturnReason] = useState('');

    const [searchSupplierTerm, setSearchSupplierTerm] = useState('');

    const [productSearchTerm, setProductSearchTerm] = useState('');

    const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);

    const [user] = useState(UserItem);

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [showSerialModal, setShowSerialModal] = useState(false);

    const [previousDue, setPreviousDue] = useState(0);

    const [refundOption, setRefundOption] = useState('credit');

    const [showRefundOptionModal, setShowRefundOptionModal] = useState(false);

    const [isSerialized, setIsSerialized] = useState(true);

    const [showQtyModal, setShowQtyModal] = useState(false);

    const [returnQty, setReturnQty] = useState(1);



    useEffect(() => {

        const fetchSuppliers = async () => {

            showLoader();

            try {

                const res = await getSuppliers();

                setSuppliers(res.data?.data || []);

            } catch (err) {

                toast.error('Failed to load suppliers');

            } finally {

                hideLoader();

            }

        };

        fetchSuppliers();

        fetchInvoiceNumber();

    }, []);



    const fetchInvoiceNumber = async () => {

        try {

            const response = await getInvoiceNumber(5);

            if (response.data?.invoice_no) {

                setInvoiceNumber(response.data.invoice_no);

            }

        } catch (error) {

            console.error('Error fetching invoice number:', error);

            toast.error('Failed to load invoice number');

        }

    };



    const fetchOrders = async () => {

        showLoader();

        try {

            const res = await ListPurchaseOrder(selectedSupplierId, shopItem?.shop_id);

            setOrders(res.data?.data || []);

            const supplier = suppliers.find(s => s.supplier_id === selectedSupplierId);

            setSelectedSupplier(supplier || null);



            if (res.data?.data) {

                const totalRemaining = res.data.data.reduce((sum, order) => {

                    return sum + parseFloat(order.remaining || 0);

                }, 0);

                setPreviousDue(totalRemaining);

            }

        } catch (err) {

            toast.error('Failed to load orders');

        } finally {

            hideLoader();

        }

    };



    useEffect(() => {

        if (selectedSupplierId) {

            fetchOrders();

        }

    }, [selectedSupplierId]);



    const role = user?.role_title?.toLowerCase();
    if (role !== "super admin" && role !== "admin") {

        return (

            <div className="alert alert-danger m-5 text-center shadow-sm">

                <h4 className="fw-bold text-danger">Access Denied</h4>

                <p className="mb-0">Only Super Admin is authorized to access the Purchase Return module.</p>

            </div>

        );

    }



    const calculateReturnAmount = () => {

        if (!selectedProduct) return 0;

        const unitPrice = parseFloat(selectedProduct?.unit_price || 0) || (parseFloat(selectedProduct?.price || 0) / parseFloat(selectedProduct?.qty || 1)) || 0;

        if (isSerialized) {

            return returnSerials.reduce((total, serial) => {

                return total + unitPrice;

            }, 0);

        } else {

            return returnQty * unitPrice;

        }

    };



    const calculateFinancials = () => {

        if (!selectedProduct) return {

            refundAmount: 0,

            creditAdjustment: 0,

            newBalance: 0,

            dueAmount: 0

        };



        const returnAmount = calculateReturnAmount();

        const dueAmount = parseFloat(selectedProduct?.remaining || 0);



        if (false && refundOption === 'credit') {

            return {

                refundAmount: 0,

                creditAdjustment: returnAmount,

                newBalance: dueAmount + returnAmount,

                dueAmount: dueAmount

            };

        } else {

            if (returnAmount <= dueAmount) {

                return {

                    refundAmount: 0,

                    creditAdjustment: returnAmount,

                    newBalance: dueAmount - returnAmount,

                    dueAmount: dueAmount

                };

            } else {

                return {

                    refundAmount: returnAmount - dueAmount,

                    creditAdjustment: dueAmount,

                    newBalance: 0,

                    dueAmount: dueAmount

                };

            }

        }

    };



    const filteredSuppliers = searchSupplierTerm

        ? suppliers.filter(s => s.status !== 1 && s.full_name?.toLowerCase().includes(searchSupplierTerm?.toLowerCase()))

        : suppliers.filter(s => s.status !== 1);



    const handleSupplierChange = (id, name) => {

        setSelectedSupplierId(id);

        setSearchSupplierTerm(name);

        setOrders([]);

        setSelectedProduct(null);

        setReturnSerials([]);

        setAvailableSerials([]);

        setReturnReason('');

        setProductSearchTerm('');

        setPreviousDue(0);

    };



    const filteredOrders = productSearchTerm

        ? orders.filter(o =>

            o.product_name?.toLowerCase().includes(productSearchTerm?.toLowerCase()) ||

            o.unique_id?.toLowerCase().includes(productSearchTerm?.toLowerCase()) ||

            o.po_id?.toLowerCase().includes(productSearchTerm?.toLowerCase())

        )

        : orders;



    const handleProductSelect = (product) => {

        try {

            const serials = product.serial_details?.filter(item => item.status === "0") || [];

            // if (serials.length === 0) {

            //     toast.error("No available serial numbers for this product");

            //     return;

            // }

            // console.log("selected product", product);

            setSelectedProduct(product);

            setReturnReason('');

            setReturnQty(1);



            if (serials.length === 0) {

                // Non-serialized item (e.g. raw material)

                setIsSerialized(false);

                setAvailableSerials([]);

                setReturnSerials([]);

                setShowQtyModal(true);

            } else {

                // Serialized item

                setIsSerialized(true);

                setAvailableSerials(serials);

                setReturnSerials([]);

                setShowSerialModal(true);

            }

        } catch (e) {

            console.error('Error parsing serial numbers:', e);

            toast.error('Error loading product details');

        }

    };



    const handleSerialSelect = (serial) => {

        setReturnSerials([...returnSerials, serial]);

        setAvailableSerials(availableSerials.filter(s => s.serial_number !== serial.serial_number));

    };



    const handleSerialRemove = (serial) => {

        setReturnSerials(returnSerials.filter(s => s.serial_number !== serial.serial_number));

        setAvailableSerials([...availableSerials, serial]);

    };



    const handleReturnSubmit = () => {

        if (isSerialized) {

            if (returnSerials.length === 0) {

                toast.error("Please select at least one serial number to return");

                return;

            }

            // handleRefundOptionSelect("refund");

        } else {

            const qtyVal = parseFloat(returnQty || 0);

            if (qtyVal <= 0) {

                toast.error("Please enter a valid quantity to return");

                return;

            }

            const maxReturnable = selectedProduct?.remaining_stock !== undefined
                ? parseFloat(selectedProduct.remaining_stock || 0)
                : parseFloat(selectedProduct?.qty || 0);

            if (qtyVal > maxReturnable) {
                const limitName = selectedProduct?.remaining_stock !== undefined ? "available stock" : "purchased quantity";
                toast.error(`Return quantity cannot exceed ${limitName} (${maxReturnable})`);

                return;

            }

        }



        if (calculateFinancials().refundAmount > 0) {

            setShowRefundOptionModal(true);

        } else {

            handleRefundOptionSelect("refund");

        }

    };



    const handleRefundOptionSelect = (option) => {

        setRefundOption(option);

        setShowRefundOptionModal(false);

        setShowConfirmModal(true);

    };



    const confirmReturn = async () => {

        showLoader();

        setShowConfirmModal(false);



        try {

            const financials = calculateFinancials();

            const returnAmount = calculateReturnAmount();



            if (financials.dueAmount > 0) {

                var paydata = {

                    orderID: selectedProduct?.po_id,

                    date: getFormattedCurrentDate2(),

                    amount: "0",

                    total_amount: selectedProduct.grand_total,

                    cash: financials.creditAdjustment,

                    credit: financials.newBalance || "0",

                    card: 0,

                    type: 1,

                    mop: "1",

                    complete: financials.newBalance > 0 ? "0" : "1",

                };

                console.log("paydata", paydata);

                await onReqCreatePayment(paydata, true);



                try {

                    const creditPayload = {

                        type: "3",

                        ref_id: selectedProduct.po_id,

                        remarks: "Purchase - Supplier Credit Adjustment",

                        date: getFormattedCurrentDate2(),

                        created_by: user?.user_id,

                        shop_id: shopItem?.id || "0",

                        amount: financials.creditAdjustment.toFixed(2),

                        is_debit: "0",

                    };

                    await postGeneralData(creditPayload);

                    const bankPayload = {

                        type: "2",

                        ref_id: selectedProduct.po_id,

                        remarks: "Bank - Supplier Credit Adjustment",

                        date: getFormattedCurrentDate2(),

                        created_by: user?.user_id,

                        shop_id: shopItem?.id || "0",

                        amount: financials.creditAdjustment.toFixed(2),

                        is_debit: "1",

                    };

                    // await postGeneralData(bankPayload);



                    if (paydata?.complete == "0") {

                        const generalDataPayload = {

                            type: "7",

                            ref_id: selectedProduct?.po_id,

                            remarks: "Purchase Credit",

                            date: getFormattedCurrentDate2(),

                            created_by: user?.user_id,

                            shop_id: shopItem?.id || "0",

                            amount: paydata.credit,

                            is_debit: "0",

                        };

                        await postGeneralData(generalDataPayload);

                    } else {

                        const paymentCompleted = {

                            type: "7",

                            shop_id: shopItem?.id || "0",

                            ref_id: selectedProduct?.po_id,

                        }

                        await UpdatePaymentComplete(paymentCompleted);

                    }

                } catch (error) {

                    console.error("General log failed:", error);

                    toast.error("Failed to create general transaction log");

                }

            }



            // If non-serialized, generate dummy serial numbers so that backend parses return_qty correctly

            const dummySerials = isSerialized

                ? returnSerials

                : Array.from({ length: parseInt(returnQty) }, (_, i) => ({

                    id: `dummy-${i}`,

                    serial_number: `NON-SERIAL-${selectedProduct.po_id}-${selectedProduct.id}-${i + 1}`,

                    p_id: selectedProduct.product_id,

                    status: "-1"

                }));



            const serialListForPayload = dummySerials.map(s => s.serial_number);



            const payload = {

                // serial_number: JSON.stringify(returnSerials.map(s => s.serial_number)),

                serial_number: JSON.stringify(serialListForPayload),

                invoice_number: JSON.stringify([{

                    unique_id: selectedProduct.po_id,

                    // serial_number: returnSerials.map(s => s.serial_number),

                    serial_number: serialListForPayload,

                    product_name: selectedProduct.product_name

                }]),

                amount: financials.refundAmount.toFixed(2),

                credit_adjustment: financials.creditAdjustment.toFixed(2),

                sales_update: JSON.stringify([{

                    id: selectedProduct.id,

                    // serial_number: returnSerials.map(s => s.serial_number).join(",")

                    serial_number: serialListForPayload.join(",")

                }]),

                unique_id: invoiceNumber,

                user_id: user?.user_id || "",

                shop_id: String(shopItem?.id || ""),

                type: "0",

                return_reason: returnReason || "",

                return_data: JSON.stringify([{

                    ...selectedProduct,

                    // return_serial_number: JSON.stringify(returnSerials),

                    // returnqty: returnSerials.length,

                    return_serial_number: JSON.stringify(dummySerials),

                    returnqty: dummySerials.length,

                    return_amount: financials.refundAmount.toFixed(2),

                    credit_adjustment: financials.creditAdjustment.toFixed(2)

                }]),

                payment_status: refundOption !== 'credit' ? 0 : 1,

                supplier_id: selectedSupplierId,

                remaining: financials.refundAmount.toFixed(2),

                remarks: financials.dueAmount > 0 ? `Amount ${financials.creditAdjustment.toFixed(2)} adjusted your previous credit` : ''

            };



            await PurchasesReturn(payload);



            try {

                if (financials.refundAmount > 0) {

                    const refundPayload = {

                        type: "3",

                        ref_id: invoiceNumber,

                        remarks: refundOption === 'credit' ? 'Purchase Return Credit' : returnReason || "Purchase Return Refund",

                        date: getFormattedCurrentDate2(),

                        created_by: user?.user_id,

                        shop_id: shopItem?.id || "0",

                        amount: financials.refundAmount,

                        is_debit: "0",

                    };

                    await postGeneralData(refundPayload);



                    const bankPayload = {

                        type: "2",

                        ref_id: invoiceNumber,

                        remarks: "Bank - Purchase Return Refund",

                        date: getFormattedCurrentDate2(),

                        created_by: user?.user_id,

                        shop_id: shopItem?.id || "0",

                        amount: financials.refundAmount.toFixed(2),

                        is_debit: "1",

                    };



                    const receiveablePayload = {

                        type: "11",

                        ref_id: invoiceNumber,

                        remarks: "Purchase Return Refund - Credit",

                        date: getFormattedCurrentDate2(),

                        created_by: user?.user_id,

                        shop_id: shopItem?.id || "0",

                        amount: financials.refundAmount.toFixed(2),

                        is_debit: "1",

                    };



                    if (refundOption == "credit") {

                        await postGeneralData(receiveablePayload);

                    } else {

                        await postGeneralData(bankPayload);

                        var paydata = {

                            orderID: selectedProduct?.po_id,

                            date: getFormattedCurrentDate2(),

                            amount: financials.refundAmount,

                            total_amount: financials.refundAmount,

                            cash: financials.refundAmount,

                            credit: 0,

                            card: 0,

                            type: 1,

                            mop: "1",

                            complete: "1",

                        };



                        await onReqCreatePayment(paydata);

                    }

                }

            } catch (err) {

                console.error("Failed to log general transaction:", err);

                toast.error("General ledger entry failed");

            }



            toast.success(

                <div>

                    <p>Purchase return processed successfully</p>

                    <p>Product: {selectedProduct.product_name}</p>

                    <p>Returned Serials: {returnSerials.length}</p>

                    <p>Total Return Value: {returnAmount.toFixed(2)}</p>

                    {refundOption === 'credit' ? (

                        <p className="text-info">

                            Credit Added: +{financials.creditAdjustment.toFixed(2)}

                        </p>

                    ) : (

                        <>

                            {financials.creditAdjustment > 0 && (

                                <p className="text-info">

                                    Credit Adjustment: -{financials.creditAdjustment.toFixed(2)}

                                </p>

                            )}

                            {financials.refundAmount > 0 && (

                                <p className="text-success">

                                    Refund Issued: +{financials.refundAmount.toFixed(2)}

                                </p>

                            )}

                        </>

                    )}

                    <p>New Credit Balance: {financials.newBalance.toFixed(2)}</p>

                </div>

            );



            setSelectedProduct(null);

            setReturnSerials([]);

            setAvailableSerials([]);

            setReturnReason('');

            setShowSerialModal(false);

            fetchInvoiceNumber();

            fetchOrders();

        } catch (error) {

            console.error("Return error:", error);

            toast.error(error.message || "Error processing return");

        } finally {

            hideLoader();

        }

    };



    return (

        <div className="return-products-container card">

            <h1>Purchase Return</h1>



            <div className="customer-search-section mb-3 col-md-6">

                <label>Supplier:</label>

                <div className="dropdown w-100">

                    <input

                        type="text"

                        className="form-control"

                        placeholder="Search Supplier"

                        value={searchSupplierTerm}

                        onChange={(e) => setSearchSupplierTerm(e.target.value)}

                        data-bs-toggle="dropdown"

                    />

                    <ul className="dropdown-menu w-100 p-1" style={{ maxHeight: '300px', overflowY: 'auto' }}>

                        {filteredSuppliers.map(s => (

                            <li key={s.supplier_id} onClick={() => handleSupplierChange(s.supplier_id, s.full_name)}>

                                <div className="card p-2 mb-1">

                                    <h5 className="card-title font-14 mb-0">{s.full_name}</h5>

                                    <p className="card-text font-13">

                                        <strong>Branch:</strong> {s.branch} <br />

                                        <strong>Phone:</strong> {s.phone}

                                    </p>

                                </div>

                            </li>

                        ))}

                    </ul>

                </div>

            </div>



            {selectedSupplier && (

                <div className="supplier-info mb-3">

                    <h4>Purchase Orders for {selectedSupplier.full_name}</h4>

                    <p className="text-muted">Supplier ID: {selectedSupplier.supplier_id}</p>

                    {previousDue > 0 && (

                        <div className="alert alert-warning">

                            <strong>Previous Due:</strong> {previousDue.toFixed(2)}

                        </div>

                    )}

                </div>

            )}



            {!selectedSupplier && (

                <div className="text-center p-5 rounded-4 mt-4" style={{ background: 'rgba(59, 130, 246, 0.02)', border: '1.5px dashed rgba(59, 130, 246, 0.2)' }}>

                    <i className="bi bi-search fs-2 text-blue-500 mb-2 d-block"></i>

                    <h5 className="font-semibold text-slate-700">Please Select a Supplier</h5>

                    <p className="text-slate-400 text-sm mb-0">Choose a supplier from the dropdown search list above to view their purchase history and process returns.</p>

                </div>

            )}



            {selectedSupplier && orders.length === 0 && (

                <div className="text-center p-5 rounded-4 mt-4 border border-dashed text-slate-500">

                    <i className="bi bi-inbox fs-2 text-slate-300 d-block mb-2"></i>

                    <h5 className="font-semibold text-slate-700">No Purchase Orders</h5>

                    <p className="text-slate-400 text-sm mb-0">There are no purchase orders recorded for this supplier in ZTR Inventory.</p>

                </div>

            )}



            {orders.length > 0 && (

                <div className="product-search mb-3 col-md-6">

                    <input

                        type="text"

                        className="form-control"

                        placeholder="Search product or order ID"

                        value={productSearchTerm}

                        onChange={(e) => setProductSearchTerm(e.target.value)}

                    />

                </div>

            )}



            {filteredOrders.length > 0 && (

                <div className="orders-table-wrapper table-responsive">

                    <table className="table table-bordered table-hover">

                        <thead className="table-light">

                            <tr>

                                <th>Action</th>

                                <th>Product</th>

                                <th>Order ID</th>

                                <th>Date</th>

                                <th>Available Qty</th>

                                <th>Credit Balance (INR)</th>

                            </tr>

                        </thead>

                        <tbody>

                            {filteredOrders.map(order => {

                                const serialDetails = order.serial_details?.filter(item => item.status === "0") || [];

                                const hasSerials = serialDetails.length > 0;

                                const totalQty = order.remaining_stock !== undefined ? parseFloat(order.remaining_stock) : parseFloat(order.qty || 0);

                                const isNonSerialized = serialDetails.length === 0;

                                const displayQty = isNonSerialized ? totalQty : serialDetails.length;

                                const isReturnable = displayQty > 0;

                                const remaining = parseFloat(order.remaining || 0);

                                return (

                                    <tr key={order.id}>

                                        <td>

                                            <button

                                                className="btn btn-outline-primary btn-sm"

                                                onClick={() => handleProductSelect(order)}

                                                // disabled={serialDetails.length === 0}

                                                disabled={!isReturnable}

                                            >

                                                Process Return

                                            </button>

                                        </td>

                                        <td>

                                            <strong>{order.product_name}</strong>

                                            {/* {serialDetails.length === 0 && (

                                                <div className="text-danger small mt-1">No available serials</div>

                                            )} */}

                                        </td>

                                        <td>{order.po_id}</td>

                                        <td>{order.date}</td>

                                        {/* <td>{serialDetails.length}</td> */}

                                        <td>{displayQty}</td>

                                        <td className={remaining > 0 ? 'text-danger' : 'text-success'}>

                                            {remaining.toFixed(2)}

                                        </td>

                                    </tr>

                                );

                            })}

                        </tbody>

                    </table>

                </div>

            )}



            <Modal show={showRefundOptionModal} onHide={() => setShowRefundOptionModal(false)} centered dialogClassName="return-modal">

                <Modal.Header closeButton className="bg-info text-white">

                    <Modal.Title>Select Refund Option</Modal.Title>

                </Modal.Header>

                <Modal.Body>

                    <div className="text-center">

                        <h5>How would you like to handle the return value?</h5>

                        <p className="mb-4">Total Return Value: {calculateReturnAmount().toFixed(2)}</p>



                        <div className="d-flex justify-content-center gap-3">

                            <button

                                className="btn btn-primary btn-lg"

                                onClick={() => handleRefundOptionSelect('credit')}

                            >

                                <i className="fas fa-file-invoice-dollar me-2"></i>

                                Apply as Credit

                            </button>

                            <button

                                className="btn btn-success btn-lg"

                                onClick={() => handleRefundOptionSelect('refund')}

                            >

                                <i className="fas fa-money-bill-wave me-2"></i>

                                Immediate Refund

                            </button>

                        </div>



                        {selectedProduct?.remaining > 0 && (

                            <div className="mt-3 alert alert-warning">

                                <strong>Note:</strong> This supplier has {parseFloat(selectedProduct?.remaining || 0).toFixed(2)} credit available

                            </div>

                        )}

                    </div>

                </Modal.Body>

            </Modal>



            <Modal show={showSerialModal} onHide={() => setShowSerialModal(false)} size="lg" dialogClassName="return-modal">

                <Modal.Header closeButton className="bg-primary text-white">

                    <Modal.Title>Select Serial Numbers for {selectedProduct?.product_name}</Modal.Title>

                </Modal.Header>

                <Modal.Body>

                    <div className="serial-selection-container">

                        <div className="row">

                            <div className="col-md-6">

                                <div className="card border-primary mb-3">

                                    <div className="card-header bg-primary text-white">

                                        Available Serial Numbers ({availableSerials.length})

                                    </div>

                                    <div className="card-body" style={{ maxHeight: '300px', overflowY: 'auto' }}>

                                        {availableSerials.length > 0 ? (

                                            <div className="d-flex flex-wrap gap-2">

                                                {availableSerials.map((serial, index) => (

                                                    <button

                                                        key={index}

                                                        className="btn btn-outline-primary btn-sm"

                                                        onClick={() => handleSerialSelect(serial)}

                                                    >

                                                        {serial.serial_number}

                                                    </button>

                                                ))}

                                            </div>

                                        ) : (

                                            <p className="text-muted">No serial numbers available</p>

                                        )}

                                    </div>

                                </div>

                            </div>



                            <div className="col-md-6">

                                <div className="card border-success mb-3">

                                    <div className="card-header bg-success text-white">

                                        Selected for Return ({returnSerials.length})

                                    </div>

                                    <div className="card-body" style={{ maxHeight: '300px', overflowY: 'auto' }}>

                                        {returnSerials.length > 0 ? (

                                            <div className="d-flex flex-wrap gap-2">

                                                {returnSerials.map((serial, index) => (

                                                    <button

                                                        key={index}

                                                        className="btn btn-success btn-sm"

                                                        onClick={() => handleSerialRemove(serial)}

                                                    >

                                                        {serial.serial_number}

                                                    </button>

                                                ))}

                                            </div>

                                        ) : (

                                            <p className="text-muted">No serial numbers selected</p>

                                        )}

                                    </div>

                                </div>

                            </div>

                        </div>



                        <div className="form-group mt-3">

                            <label>Return Reason (Optional)</label>

                            <textarea

                                className="form-control"

                                value={returnReason}

                                onChange={(e) => setReturnReason(e.target.value)}

                                placeholder="Enter reason for return..."

                                rows={3}

                            />

                        </div>



                        <div className="d-flex justify-content-between mt-3">

                            <div>

                                <h5>Total Selected: {returnSerials.length}</h5>

                                <h5>Return Amount: {calculateReturnAmount().toFixed(2)}</h5>

                                {selectedProduct?.remaining > 0 && (

                                    <h5 className="text-warning">Credit Available: {parseFloat(selectedProduct?.remaining || 0).toFixed(2)}</h5>

                                )}

                            </div>

                            <button

                                className="btn btn-primary"

                                onClick={handleReturnSubmit}

                                disabled={returnSerials.length === 0}

                            >

                                Continue to Confirmation

                            </button>

                        </div>

                    </div>

                </Modal.Body>

            </Modal>



            {/* Non-Serialized Quantity Return Modal */}

            <Modal show={showQtyModal} onHide={() => setShowQtyModal(false)} centered dialogClassName="return-modal">

                <Modal.Header closeButton className="bg-primary text-white">

                    <Modal.Title>Enter Return Quantity for {selectedProduct?.product_name}</Modal.Title>

                </Modal.Header>

                <Modal.Body>

                    <div className="p-3">

                        <div className="mb-3">

                            <label className="form-label fw-bold">Purchased Qty:</label>

                            <span className="ms-2 badge bg-secondary">{selectedProduct?.qty}</span>

                        </div>

                        {selectedProduct?.remaining_stock !== undefined && (
                            <div className="mb-3">

                                <label className="form-label fw-bold text-info">Available In Stock:</label>

                                <span className="ms-2 badge bg-info">{parseFloat(selectedProduct.remaining_stock).toFixed(2)}</span>

                            </div>
                        )}

                        <div className="mb-3">

                            <label className="form-label fw-bold">Unit Price (INR):</label>

                            <span className="ms-2 text-success fw-bold">
                                {parseFloat(selectedProduct?.unit_price || (parseFloat(selectedProduct?.price || 0) / parseFloat(selectedProduct?.qty || 1)) || 0).toFixed(2)}
                            </span>

                        </div>

                        <div className="mb-3">

                            <label className="form-label fw-bold">Quantity to Return:</label>

                            <input

                                type="number"

                                className="form-control"

                                min={1}

                                max={selectedProduct?.remaining_stock !== undefined ? parseFloat(selectedProduct.remaining_stock) : parseFloat(selectedProduct?.qty || 0)}

                                value={returnQty}

                                onChange={(e) => {

                                    const maxVal = selectedProduct?.remaining_stock !== undefined
                                        ? parseFloat(selectedProduct.remaining_stock || 0)
                                        : parseFloat(selectedProduct?.qty || 0);

                                    const val = Math.min(

                                        maxVal,

                                        Math.max(1, parseInt(e.target.value) || 1)

                                    );

                                    setReturnQty(val);

                                }}

                            />

                        </div>

                        <div className="mb-3">

                            <label className="form-label fw-bold">Return Reason (Optional):</label>

                            <textarea

                                className="form-control"

                                value={returnReason}

                                onChange={(e) => setReturnReason(e.target.value)}

                                placeholder="Enter reason for return..."

                                rows={3}

                            />

                        </div>

                        <hr />

                        <div className="d-flex justify-content-between align-items-center">

                            <div>

                                <h5 className="mb-0">Return Amount: <span className="text-primary">INR {calculateReturnAmount().toFixed(2)}</span></h5>

                            </div>

                            <button

                                className="btn btn-primary"

                                onClick={() => {

                                    setShowQtyModal(false);

                                    if (calculateFinancials().refundAmount > 0) {

                                        setShowRefundOptionModal(true);

                                    } else {

                                        handleRefundOptionSelect("refund");

                                    }

                                }}

                            >

                                Continue to Confirmation

                            </button>

                        </div>

                    </div>

                </Modal.Body>

            </Modal>



            <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} size="lg" dialogClassName="return-modal">

                <Modal.Header closeButton className="bg-danger text-white">

                    <Modal.Title>Confirm Purchase Return</Modal.Title>

                </Modal.Header>

                <Modal.Body>

                    <div className="return-confirmation">

                        <div className="alert alert-warning">

                            <strong>Warning:</strong> This action cannot be undone. Please verify all details before confirming.

                        </div>



                        <h5 className="mb-3">Return Summary</h5>



                        <div className="alert alert-info">

                            <strong>Processing as:</strong> {refundOption === 'credit' ? (

                                <span className="text-primary">CREDIT NOTE</span>

                            ) : (

                                <span className="text-success">IMMEDIATE REFUND</span>

                            )}

                        </div>



                        <div className="row mb-3">

                            <div className="col-md-6">

                                <div className="card">

                                    <div className="card-header bg-light">

                                        <strong>Product Details</strong>

                                    </div>

                                    <div className="card-body">

                                        <table className="table table-sm">

                                            <tbody>

                                                <tr>

                                                    <td><strong>Product Name:</strong></td>

                                                    <td>{selectedProduct?.product_name}</td>

                                                </tr>

                                                <tr>

                                                    <td><strong>Order ID:</strong></td>

                                                    <td>{selectedProduct?.po_id}</td>

                                                </tr>

                                                <tr>

                                                    <td><strong>Unit Price:</strong></td>

                                                    <td>{parseFloat(selectedProduct?.unit_price || (parseFloat(selectedProduct?.price || 0) / parseFloat(selectedProduct?.qty || 1)) || 0).toFixed(2)}</td>

                                                </tr>

                                                <tr>

                                                    <td><strong>Available Credit:</strong></td>

                                                    <td>{parseFloat(selectedProduct?.remaining || 0).toFixed(2)}</td>

                                                </tr>

                                            </tbody>

                                        </table>

                                    </div>

                                </div>

                            </div>



                            <div className="col-md-6">

                                <div className="card">

                                    <div className="card-header bg-light">

                                        <strong>Return Summary</strong>

                                    </div>

                                    <div className="card-body">

                                        <table className="table table-sm">

                                            <tbody>

                                                <tr>

                                                    <td><strong>Processing Method:</strong></td>

                                                    <td className={refundOption === 'credit' ? 'text-primary' : 'text-success'}>

                                                        {refundOption === 'credit' ? 'Credit Note' : 'Immediate Refund'}

                                                    </td>

                                                </tr>

                                                <tr>

                                                    <td><strong>Items Returning:</strong></td>

                                                    {/* <td>{returnSerials.length}</td> */}

                                                    <td>{isSerialized ? returnSerials.length : returnQty}</td>

                                                </tr>

                                                <tr>

                                                    <td><strong>Total Value:</strong></td>

                                                    <td>{calculateReturnAmount().toFixed(2)}</td>

                                                </tr>

                                                {false && refundOption === 'credit' ? (

                                                    <tr className="table-info">

                                                        <td><strong>Credit To Be Added:</strong></td>

                                                        <td>+{calculateReturnAmount().toFixed(2)}</td>

                                                    </tr>

                                                ) : (

                                                    <>

                                                        {calculateFinancials().creditAdjustment > 0 && (

                                                            <tr className="table-info">

                                                                <td><strong>Credit Applied:</strong></td>

                                                                <td>-{calculateFinancials().creditAdjustment.toFixed(2)}</td>

                                                            </tr>

                                                        )}

                                                        {calculateFinancials().refundAmount > 0 && (

                                                            <tr className="table-success">

                                                                <td><strong>Refund Amount:</strong></td>

                                                                <td>+{calculateFinancials().refundAmount.toFixed(2)}</td>

                                                            </tr>

                                                        )}

                                                    </>

                                                )}

                                                <tr className="table-active">

                                                    <td><strong>New Credit Balance:</strong></td>

                                                    <td>{calculateFinancials().newBalance.toFixed(2)}</td>

                                                </tr>

                                            </tbody>

                                        </table>

                                    </div>

                                </div>

                            </div>

                        </div>



                        {isSerialized && returnSerials.length > 0 && (

                            <div className="card mb-3">

                                <div className="card-header bg-light">

                                    <strong>Selected Serial Numbers</strong>

                                </div>

                                <div className="card-body">

                                    <div className="d-flex flex-wrap gap-2">

                                        {returnSerials.map((serial, index) => (

                                            <span key={index} className="badge bg-success text-white p-2">

                                                {serial.serial_number}

                                            </span>

                                        ))}

                                    </div>

                                </div>

                            </div>

                        )}



                        {returnReason && (

                            <div className="card">

                                <div className="card-header bg-light">

                                    <strong>Return Reason</strong>

                                </div>

                                <div className="card-body">

                                    {returnReason}

                                </div>

                            </div>

                        )}

                    </div>

                </Modal.Body>

                <Modal.Footer>

                    <Button variant="secondary" onClick={() => {

                        setShowConfirmModal(false);

                        setShowRefundOptionModal(true);

                    }}>

                        <i className="fas fa-arrow-left me-2"></i> Change Method

                    </Button>

                    <Button variant="danger" onClick={confirmReturn}>

                        <i className="fas fa-check-circle me-2"></i> Confirm Return

                    </Button>

                </Modal.Footer>

            </Modal>

        </div>

    );

};



export default PurchaseReturn;